import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PromoService } from 'src/app/_servizi/promo.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-promo',
  templateUrl: './dialog-promo.component.html',
  styleUrls: ['./dialog-promo.component.css']
})
export class DialogPromoComponent implements OnInit {

  form: UntypedFormGroup;
  azione = 'riscattaCodicePromo';
  risultato = null;

  codiceFormControl = new UntypedFormControl('', [Validators.required]);

  constructor(
    private promoService: PromoService,
    public router: Router,
    public dialogRef: MatDialogRef<DialogPromoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = new UntypedFormGroup({
      codicepromo: this.codiceFormControl
    });
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  riscatta() {
    this.risultato = null;
    this.promoService.riscattaCodicePromo(this.data.idVisita, this.data.codiceForm, this.form.value.codicepromo)
      .subscribe(response => {
        if (response.length > 0) {
          if ((this.form.value.codicepromo + '').includes('-')) {
            this.controllaRegalo(response[0]);
          } else {
            this.controllaPromo(response[0]);
          }
        } else {
          this.risultato = {
            risultato: false,
            codice: '',
            valore: 0,
            label: '',
            errore: 'promodialogo.nonvalido',
            data1: '',
            data2: '',
            promo: null
          };
        }
      });
  }
  controllaPromo(promodacontrollare) {
    this.risultato = this.promoService.controllaPromo(
      promodacontrollare, this.data.nposti, this.data.costoTotale, this.data.costoSingolo, this.form.value.codicepromo
    );
    if (this.risultato.risultato) {
      this.dialogRef.close(this.risultato);
    }
  }
  controllaRegalo(promodacontrollare) {
    this.risultato = this.promoService.controllaRegalo(
      promodacontrollare, this.data.nposti, this.data.costoTotale, this.data.costoSingolo, this.form.value.codicepromo
    );
    if (this.risultato.risultato) {
      this.dialogRef.close(this.risultato);
    }
  }
}
